<!-- @format -->

<template>
  <div style="border-radius:8px;background:#fff; box-shadow: 1px 1px 9px rgba(16,55,126,0.21)">
    <!-- <Card :bordered="false" > -->
    <div
      v-if="loginin && !forgetpwd"
      style="
        height: 56px;
        width: 100%;
        background: #f4f7fe;
        border-radius: 8px 8px 0px 0px;
        line-height: 56px;
        text-align: center;
      "
    >
      <p style="font-size: 18px; font-weight: bold; color: #333333">
        企业登录/注册
      </p>
    </div>
    <div class="cardbox">
      <div v-if="loginin && !forgetpwd" class="cardcontent">
        <div class="changecont">
          <Tabs value="pwd">
            <TabPane label="密码登录" name="pwd">
              <div style="width: 100%; height: 215px">
                <div class="modinp">
                  <Form ref="formValidate" :model="loginform" :rules="ruleValidatelogin" @keydown.enter.native="loginsubmit('formValidate')">
                    <FormItem style="margin-bottom: 22px" prop="phone">
                      <Input type="text" v-model="loginform.phone" placeholder="请输入注册手机号" />
                    </FormItem>
                    <FormItem style="margin-bottom: 16px" prop="pwd">
                      <Input type="password" password v-model="loginform.pwd" placeholder="请输入密码" />
                    </FormItem>

                    <p class="forgetpwdstyle" @click="forgetpw">
                      忘记密码
                    </p>
                    <FormItem>
                      <Button type="primary" style="width: 100%; height: 42px; font-size: 16px" @click="loginsubmit('formValidate')">登录</Button>
                    </FormItem>
                  </Form>
                </div>
              </div>

              <div
                style="
                  font-size: 14px;
                  color: #576b95;
                  display: flex;
                  cursor: pointer;
                  justify-content: center;
                "
                @click="goreguister"
              >
                <p style="margin-right: 4px">立即注册</p>
                <i class="iconfont icon_zhuce"></i>
              </div>
            </TabPane>
            <TabPane label="验证码登录" name="code">
              <div class="modinp">
                <Form ref="formValidatecode" :model="codeform" :rules="ruleValidatecode" @keydown.enter.native="codesubmit('formValidatecode')">
                  <FormItem prop="phone">
                    <Input type="text" v-model="codeform.phone" placeholder="请输入手机号" @on-change="changeipvallog('login')" />
                  </FormItem>
                  <FormItem prop="code">
                    <Row>
                      <Col span="15">
                        <Input type="text" v-model="codeform.code" placeholder="请输入短信验证码" />
                      </Col>
                      <Col span="6" offset="1">
                        <Button
                          type="primary"
                          v-if="!isShowGetCode"
                          style="width: 100px; height: 42px; font-size: 14px"
                          :disabled="logisvalue"
                          @click="getIdentifyCode('codeform')"
                          >获取验证码</Button
                        >
                        <Button type="primary" v-else style="padding: 5px 0;width: 100px; height: 42px; font-size: 14px" disabled
                          >{{ this.countdown }}s后可重试</Button
                        >
                      </Col>
                    </Row>
                  </FormItem>
                  <!-- <FormItem> -->
                  <Button type="primary" style="width: 100%; height: 42px; font-size: 16px;margin:8px 0 16px 0" @click="codesubmit('formValidatecode')"
                    >立即登录</Button
                  >
                  <!-- </FormItem> -->
                </Form>
              </div>

              <div>
                <p style="font-size: 12px; color: #999999">
                  未注册的用户，登录成功后将自动注册为本招聘平台的企业用户。
                </p>
              </div>
            </TabPane>
          </Tabs>
        </div>

        <!-- <div v-if="istext">
                <p style="font-size: 12px;color: #999999;">未注册的手机号，登录成功后将自动注册为本次招聘会的参会企业客户。</p>
            </div>

            <div v-else style="font-size: 14px;color: #576B95;display:flex;cursor:pointer" @click="goreguister">
                <p style="margin-right:4px">立即注册</p>
                <i class="iconfont icon_zhuce"></i>
            </div> -->
      </div>

      <div v-else-if="!loginin && !forgetpwd" class="cardcontent" style="padding-bottom:20px">
        <p class="commp">新用户注册</p>
        <div class="modinp" style="margin-top: 32px">
          <Form
            ref="formValidatereguister"
            :model="reguisterform"
            :rules="ruleValidatereguister"
            @keydown.enter.native="reguistersubmit('formValidatereguister')"
          >
            <FormItem prop="phone">
              <Input type="text" v-model="reguisterform.phone" placeholder="请输入常用手机号" @on-change="changeipvallog('regu')" />
            </FormItem>
            <FormItem prop="code">
              <Row>
                <Col span="14">
                  <Input type="text" v-model="reguisterform.code" placeholder="请输入短信验证码" />
                </Col>
                <Col span="6" offset="1">
                  <Button
                    type="primary"
                    v-if="!isShowGetCodereg"
                    style="width: 110px; height: 42px; font-size: 14px"
                    :disabled="regisvalue"
                    @click="getIdentifyCode('reguisterform')"
                    >获取验证码</Button
                  >
                  <Button type="primary" v-else style="width: 112px; height: 42px; font-size: 14px" disabled>{{ this.countdownreg }}s后可重试</Button>
                </Col>
              </Row>
            </FormItem>
            <!-- <FormItem prop="pwd">
                                    <Input type="password" password v-model="reguisterform.pwd" placeholder="请设置6-16位密码"/>
                                </FormItem> -->
            <FormItem v-if="!pwdflag" style="margin-bottom: 26px" prop="pwd">
              <Input type="password" v-model="reguisterform.pwd" placeholder="请设置6-16位密码">
                <i slot="suffix" class="iconfont icon_eye-close" @click="handlePassword" style="font-size:18px"></i>

                <!-- <Icon
                  @click="handlePassword"
                  slot="suffix"
                  type="ios-eye-off-outline"
                  size="22"
                  style="margin-top: 6px"
                /> -->
              </Input>
            </FormItem>

            <FormItem v-else style="margin-bottom: 26px" prop="pwd">
              <Input type="text" v-model="reguisterform.pwd" placeholder="请设置6-16位密码">
                <i slot="suffix" class="iconfont icon_eye-open" @click="handlePassword" style="font-size:18px"></i>

                <!-- <Icon
                  @click="handlePassword"
                  slot="suffix"
                  type="ios-eye-outline"
                  size="22"
                  style="margin-top: 6px"
                /> -->
              </Input>
            </FormItem>

            <Button type="primary" style="width: 100%; height: 42px; font-size: 16px;margin:8px 0 16px 0" @click="reguistersubmit('formValidatereguister')"
              >注册</Button
            >

            <div style="display: flex; width: 300px; justify-content: center">
              <p style="font-size: 14px; color: #999999; line-height: 14px">
                已有账号，
              </p>
              <p
                style="
                  font-size: 14px;
                  color: #576b95;
                  line-height: 14px;
                  cursor: pointer;
                "
                @click="backlogin"
              >
                去登录
              </p>
            </div>
          </Form>
        </div>
      </div>

      <div v-else-if="!loginin && forgetpwd" class="cardcontent">
        <p class="commp">忘记密码</p>

        <div v-if="!beforbtn" style="display: flex; flex-direction: column; margin: 0 auto">
          <div>
            <div class="boxone">
              <div class="boxtwo">
                <div class="changebox">
                  <div class="yuanbox">1</div>
                  <p style="margin-top: 8px; color: #666; font-size: 14px">
                    验证手机号
                  </p>
                </div>

                <div class="changebox">
                  <div class="yuanbox" style="background: #ccc">2</div>
                  <p style="margin-top: 8px; color: #999; font-size: 14px">
                    重置密码
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="modinp" style="margin-top: 50px">
            <Form ref="formValidatecheck" :model="checkform" :rules="ruleValidatecheck" @keydown.enter.native="fondpwd('formValidatecheck')">
              <FormItem prop="phone">
                <Input type="text" v-model="checkform.phone" placeholder="请输入注册手机号" @on-change="changeipvallog('check')" />
              </FormItem>
              <FormItem prop="code">
                <Row>
                  <Col span="14">
                    <Input type="text" v-model="checkform.code" placeholder="请输入短信验证码" />
                  </Col>
                  <Col span="6" offset="1">
                    <Button
                      type="primary"
                      v-if="!isShowGetCodefor"
                      style="width: 110px; height: 42px; font-size: 14px"
                      :disabled="checkvalue"
                      @click="getIdentifyCode('checkform')"
                      >获取验证码</Button
                    >
                    <Button type="primary" v-else style="width: 112px; height: 42px; font-size: 14px" disabled>{{ this.countdownfor }}s后可重试</Button>
                  </Col>
                </Row>
              </FormItem>

              <Button type="primary" style="width: 100%; height: 42px; font-size: 16px;margin:8px 0 16px 0" @click="fondpwd('formValidatecheck')"
                >找回密码</Button
              >
            </Form>
          </div>
        </div>

        <div v-else style="display: flex; flex-direction: column; margin: 0 auto">
          <div>
            <div class="boxone">
              <div class="boxtwo">
                <div class="changebox">
                  <div class="yuanbox" style="background: #ccc">1</div>
                  <p style="margin-top: 8px; color: #999; font-size: 14px">
                    验证手机号
                  </p>
                </div>

                <div class="changebox">
                  <div class="yuanbox">2</div>
                  <p style="margin-top: 8px; color: #666; font-size: 14px">
                    重置密码
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="modinp" style="margin-top: 66px">
            <Form ref="formValidatefirm" :model="firmform" :rules="ruleValidatefirm" @keydown.enter.native="confirmpwd('formValidatefirm')">
              <!-- <FormItem prop="pwd2">
                            <Input type="text" v-model="firmform.pwd2" placeholder="请输入6-16位新的密码" />
                        </FormItem> -->
              <div>
                <FormItem v-if="!findpwdflag" prop="pwd2">
                  <Input type="password" v-model="firmform.pwd2" placeholder="请输入6-16位新的密码">
                    <i slot="suffix" class="iconfont icon_eye-close" @click="handlePasswordch" style="font-size:18px"></i>
                    <!-- <Icon
                      @click="handlePasswordch"
                      slot="suffix"
                      type="ios-eye-off-outline"
                      size="22"
                      style="margin-top: 6px"
                    /> -->
                  </Input>
                </FormItem>

                <FormItem v-else prop="pwd2">
                  <Input type="text" v-model="firmform.pwd2" placeholder="请输入6-16位新的密码">
                    <i slot="suffix" class="iconfont icon_eye-open" @click="handlePasswordch" style="font-size:18px"></i>

                    <!-- <Icon
                      @click="handlePasswordch"
                      slot="suffix"
                      type="ios-eye-outline"
                      size="22"
                      style="margin-top: 6px"
                    /> -->
                  </Input>
                </FormItem>
              </div>

              <div>
                <FormItem v-if="!findpwdflag2" prop="againpwd">
                  <Input type="password" v-model="firmform.againpwd" placeholder="请再次输入密码">
                    <i slot="suffix" class="iconfont icon_eye-close" @click="handlePasswordch2" style="font-size:18px"></i>

                    <!-- <Icon
                      @click="handlePasswordch2"
                      slot="suffix"
                      type="ios-eye-off-outline"
                      size="22"
                      style="margin-top: 6px"
                    /> -->
                  </Input>
                </FormItem>

                <FormItem v-else prop="againpwd">
                  <Input type="text" v-model="firmform.againpwd" placeholder="请再次输入密码">
                    <i slot="suffix" class="iconfont icon_eye-open" @click="handlePasswordch2" style="font-size:18px"></i>

                    <!-- <Icon
                      @click="handlePasswordch2"
                      slot="suffix"
                      type="ios-eye-outline"
                      size="22"
                      style="margin-top: 6px"
                    /> -->
                  </Input>
                </FormItem>
              </div>

              <!-- <FormItem prop="againpwd">
                            <Input type="text" v-model="firmform.againpwd" placeholder="请再次输入密码" />
                        </FormItem> -->

              <Button type="primary" style="width: 100%; height: 42px; font-size: 16px;margin:8px 0 16px 0" @click="confirmpwd('formValidatefirm')"
                >确定</Button
              >
            </Form>
          </div>
        </div>

        <div style="display: flex; width: 300px; justify-content: center">
          <p
            style="
              font-size: 14px;
              color: #576b95;
              line-height: 14px;
              cursor: pointer;
            "
            @click="backlogin"
          >
            返回登录
          </p>
        </div>
      </div>
    </div>
    <Modal v-model="errorModal" footer-hide class="invoiceModal" :width="542">
      <h4>{{ errorMsg }}</h4>
      <div><img :src="company_concat_qr_code_url" alt="" /></div>
      <p>微信扫码联系客服</p>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import store from '@/store'
// import { user_register, forgetpassword, checksmscode } from '@/api/user'
import { register, forgetpassword, checksmscode,comlogin } from '@/api/user'
import { error_code_map } from './captcha_error_code.js'
import Cookies from 'js-cookie'
import { getcominfo } from '@/api/indexPage.js'

export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('新密码不能为空'))
      } else if (value !== this.firmform.pwd2) {
        callback('两次输入的密码不一致')
      } else {
        callback()
      }
    }
    return {
      company_concat_qr_code_url: '',
      errorMsg: '',
      errorModal: false,
      loginform: {
        phone: '',
        pwd: ''
      },
      codeform: {
        phone: '',
        code: ''
      },
      reguisterform: {
        phone: '',
        code: '',
        pwd: ''
      },
      checkform: {
        phone: '',
        code: ''
      },

      firmform: {
        pwd2: '',
        againpwd: ''
      },

      logisvalue: true,
      pwdflag: false,

      findpwdflag: false,
      findpwdflag2: false,

      countdown: 30,
      countdownreg: 30,
      countdownfor: 30,

      isShowGetCode: false,
      isShowGetCodereg: false,
      isShowGetCodefor: false,

      regisvalue: true,
      checkvalue: true,
      loginin: true,
      forgetpwd: false,
      beforbtn: false,
      ruleValidatelogin: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            pattern: /^[0-9a-zA-Z!\@\#\$\%]{6,16}$/,
            message: '密码须为6-16位，特殊字符仅支持!@#$%',
            trigger: 'blur'
          }
        ]
      },

      ruleValidatecode: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            pattern: /^[0-9]{6}$/,
            message: '请输入正确的验证码',
            trigger: 'blur'
          }
        ]
      },

      ruleValidatereguister: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            pattern: /^[0-9]{6}$/,
            message: '请输入正确的验证码',
            trigger: 'blur'
          }
        ],
        pwd: [
          { required: true, message: '请设置密码', trigger: 'blur' },
          {
            pattern: /^[0-9a-zA-Z!\@\#\$\%]{6,16}$/,
            message: '密码须为6-16位，特殊字符仅支持!@#$%',
            trigger: 'blur'
          }
        ]
      },

      ruleValidatecheck: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            pattern: /^[0-9]{6}$/,
            message: '请输入正确的验证码',
            trigger: 'blur'
          }
        ]
      },

      ruleValidatefirm: {
        pwd2: [
          { required: true, message: '请输入新密码', trigger: 'change' },
          {
            pattern: /^[0-9a-zA-Z!\@\#\$\%]{6,16}$/,
            message: '密码须为6-16位，特殊字符仅支持!@#$%',
            trigger: 'change'
          }
        ],
        againpwd: [{ required: true, validator: validatePhone, trigger: 'change' }]
      }
    }
  },

  computed: {
    defualtContactInfo() {
      return this.$store.state.user.siteInfo
    }
  },
  created() {
    this.getcominfos()
  },
  methods: {
    ...mapActions(['handleLogin', 'sendCode', 'getCompanyStatus']),
    getcominfos () {
      console.log()
      let data = {
        domain: location.host
      }
      getcominfo(data).then(res => {
        // console.log('res===========',res)
        if (res.apiStatus) {
          this.company_concat_qr_code_url = res.company_concat_qr_code_url
        }
      })
    },
    handlePasswordch2() {
      this.findpwdflag2 = !this.findpwdflag2
    },

    handlePasswordch() {
      this.findpwdflag = !this.findpwdflag
    },

    getIdentifyCode(formname) {
      if (/^1[3456789]\d{9}$/.test(this[formname].phone)) {
        this.captchaCheck(formname)
      } else {
        this.$Message.error('请输入正确的手机号')
      }
    },

    countDown(formname) {
      const self = this
      this.timer = setInterval(() => {
        if (formname == 'codeform') {
          self.countdown--
          if (self.countdown === 0) {
            clearInterval(self.timer)
            self.countdown = 30
            self.isShowGetCode = false
          }
        } else if (formname == 'reguisterform') {
          self.countdownreg--
          if (self.countdownreg === 0) {
            clearInterval(self.timer)
            self.countdownreg = 30
            self.isShowGetCodereg = false
          }
        } else if (formname == 'checkform') {
          self.countdownfor--
          if (self.countdownfor === 0) {
            clearInterval(self.timer)
            self.countdownfor = 30
            self.isShowGetCodefor = false
          }
        }
      }, 1000)
    },

    //验证码登录拖动
    captchaCheck(formname) {
      try {
        let appid = '199221841'
        let captcha = new TencentCaptcha(appid, res => {
          // 用户滑动结束或者关闭弹窗，腾讯返回的内容
          if (res.ret === 0) {
            if (res.errorCode || res.errorMessage) {
              this.errorModal = true
              this.errorMsg = res.errorCode + ': ' + error_code_map[res.errorCode]
              return
            }
            this.handleSendCode(formname, res.appid, res.randstr, res.ticket)
          }
        })
        // 滑块显示
        captcha.show()
      } catch (error) {
        this.errorModal = true
        this.errorMsg = '当前上网环境异常，请更换网络环境或稍后再试'
      }
    },

    //密码登录拖动
    captchaCheckPassword() {
      try {
        let appid = '199456950'
        let captcha = new TencentCaptcha(appid, res => {
          // 用户滑动结束或者关闭弹窗，腾讯返回的内容
          if (res.ret === 0) {
            if (res.errorCode || res.errorMessage) {
              this.errorModal = true
              this.errorMsg = res.errorCode + ': ' + error_code_map[res.errorCode]
              return
            }
            this.dologin(res.appid, res.randstr, res.ticket)
          }
        })
        // 滑块显示
        captcha.show()
      } catch (error) {
        this.errorModal = true
        this.errorMsg = '当前上网环境异常，请更换网络环境或稍后再试'
      }
    },

    handleSendCode(formname, captcha_appid, captcha_randstr, captcha_ticket) {
      let service_code = ''

      if (formname == 'codeform') {
        service_code = 1
      } else if (formname == 'reguisterform') {
        service_code = 2
      } else if (formname == 'checkform') {
        service_code = 3
      }

      this.sendCode({
        phone: this[formname].phone,
        service_code,
        type: 2,
        captcha_appid,
        captcha_randstr,
        captcha_ticket
      }).then(
        res => {
          this.countDown(formname)
          if (formname == 'codeform') {
            this.isShowGetCode = true
          } else if (formname == 'reguisterform') {
            this.isShowGetCodereg = true
          } else if (formname == 'checkform') {
            this.isShowGetCodefor = true
          }
        },
        err => {
          if (err.code === 30001) {
            this.$Message.warning('该手机号尚未注册，请先注册')
          } else {
            this.$Message.warning(err.data.msg)
          }
          // if (err.code === 20004) {
          //   this.$Message.info({
          //     content: "验证码错误，请重新输入",
          //   });
          // } else {
          //   this.$Message.error(err.msg);
          // }
        }
      )
    },

    handlePassword() {
      this.pwdflag = !this.pwdflag
    },

    confirmpwd(name) {
      // if(!this.firmform.pwd){
      //     this.$Message.error('请输入新密码');
      //     return
      // }

      // if(!/^[0-9a-zA-Z!\@\#\$\%]{6,16}$/.test(this.firmform.pwd)){
      //     this.$Message.error('密码需为6-16位，特殊字符仅支持!@#$%');
      //     return
      // }

      // if(!this.firmform.againpwd){
      //     this.$Message.error('请再次输入密码');
      //     return
      // }

      // if(this.firmform.againpwd !== this.firmform.pwd){
      //     this.$Message.error('两次输入的密码不一致');
      //     return
      // }
      this.$refs[name].validate(valid => {
        if (valid) {
          let data = {
            phone: this.checkform.phone,
            type: 2,
            sms_code: this.checkform.code,
            password: this.firmform.pwd2,
            confirm_password: this.firmform.againpwd
          }
          forgetpassword(data).then(res => {
            if (res.apiStatus) {
              this.$Message.success('密码修改成功，请使用新密码登录')
              this.forgetpwd = false
              this.loginin = true
            } else {
              this.$Message.warning(res.data.msg)
            }
          })
        } else {
        }
      })
    },

    fondpwd(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let data = {
            phone: this.checkform.phone,
            type: 2,
            service_code: 3,
            sms_code: this.checkform.code
          }

          checksmscode(data).then(res => {
            console.log('fondpwd(',res)
            if (res.apiStatus) {
              this.beforbtn = true
            } else {
              this.$Message.warning(res.data.msg)
            }
          })
        } else {
          // this.$Message.error('表单错误!');
        }
      })
    },

    reguistersubmit(name) {
      this.$refs[name].validate(valid => {
        if (!valid) return

        let data = {
          phone: this.reguisterform.phone,
          type: 2,
          sms_code: this.reguisterform.code,
          password: this.reguisterform.pwd
        }

        register(data).then(res => {
          // if (res.data.code !== 0) return this.$Message.warning(res.data.msg)
          // this.$Message.success('注册成功，请填写企业信息')
          // this.$store.commit('setToken', res.data.data.user_id)
          // this.$router.push({ path: '/company/create' })
          if (res.apiStatus) {
            this.clearCookieData()
            // this.$Message.success("注册成功");
            Cookies.set('com_key_user', res.user_id, { expires: 14 })
            Cookies.set("login_type", 'company',{expires:14});
            if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari') {
              window.location.href = `${window.location.origin}/company/#/?isregu=true`
            } else {
              window.open(`${window.location.origin}/company/#/?isregu=true`)
            }
            // window.open(`https://qiye.biyeshen.cn/#/loading?phone=${this.form.phone}&smscode=${this.form.smsCode}`)

            this.$emit('func', this.msgflag)
            this.$refs[name].resetFields()
          } else {
            this.$Message.warning(res.data.msg)
          }
        })
      })
    },
    // 企业登录成功清除  学校，学生信息
    clearCookieData() {
        Cookies.remove('user_id')
        Cookies.remove('resume_data')
        Cookies.remove('channel_userid')
        Cookies.remove('user_name')
        Cookies.remove('user_school')
        Cookies.remove('user_type')
        Cookies.remove('strategy')
        sessionStorage.removeItem('studentInfo')
        sessionStorage.removeItem('resume_data')

        Cookies.remove('channel_userid')
        Cookies.remove('channel_channel_name')
    },
    codesubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.handleLogin({
            phone: this.codeform.phone,
            type: 2,
            login_type: 1,
            smsCode: this.codeform.code
          }).then(
            res => {
              // this.$Message.success('登录成功!')
              // store
              //   .dispatch('getCompanyStatus', {
              //     user_id: res.data.user_id
              //   })
              //   .then(
              //     userCompany => {
              //       // 公司状态，1：审核中；2：审核通过；3：审核拒绝 ； null：无信息
              //       if (!userCompany.status) {
              //         this.$router.push({ path: '/company/create' })
              //       } else {
              //         this.$router.push({ path: '/home' })
              //       }
              //     },
              //     err => {
              //       onNetError(err, this)
              //     }
              //   )
              if(res.apiStatus) {
                  this.clearCookieData()
                  this.$emit('closeCompanyDialog')
                  Cookies.set('com_key_user', res.user_id, { expires: 14 })
                  Cookies.set("login_type", 'company',{expires:14});
                  window.location.href = `${window.location.origin}/company/#/`
                  this.$refs[name].resetFields()
                } else {
                  console.log('--错误--',res)
                  this.$Message.warning(res.data.msg)
                }
            },
            err => {
              this.$Message.warning(err.data.msg)
            }
          )
        } else {
          // this.$Message.error('表单错误!');
        }
      })
    },
    loginsubmit(name) {
      this.$refs[name].validate(valid => {
        if (!valid) return
        this.captchaCheckPassword()
      })
    },
    dologin(captcha_appid, captcha_randstr, captcha_ticket) {
      comlogin({
        phone: this.loginform.phone,
        type: 2,
        login_type: 2,
        password: this.loginform.pwd,
        captcha_appid,
        captcha_randstr,
        captcha_ticket
      }).then(
        res => {
          if(res.apiStatus) {
              this.clearCookieData()
              this.$emit('closeCompanyDialog')
              Cookies.remove('user_id')
              Cookies.set('com_key_user', res.user_id, { expires: 14 })
              Cookies.set("login_type", 'company',{expires:14});
              window.location.href = `${window.location.origin}/company/#/`
              this.$refs[name].resetFields()
            }else {
              this.$Message.warning(res.data.msg)
            }
        },
        err => {
          this.$Message.warning(err.data.msg)
        }
      )
    },
    forgetpw() {
      this.forgetpwd = true
      this.loginin = false
    },
    backlogin() {
      this.forgetpwd = false
      this.loginin = true
      this.beforbtn = false
    },
    goreguister() {
      this.forgetpwd = false
      this.loginin = false
    },

    changeipvallog(mark) {
      switch (mark) {
        case 'login':
          // if(this.reguisterform.phone.length == 11){
          if (/^1[3456789]\d{9}$/.test(this.codeform.phone)) {
            this.logisvalue = false
          } else {
            this.logisvalue = true
          }
          // }
          break
        case 'regu':
          // if(this.reguisterform.phone.length == 11){
          if (/^1[3456789]\d{9}$/.test(this.reguisterform.phone)) {
            this.regisvalue = false
          } else {
            this.regisvalue = true
          }
          // }
          break
        case 'check':
          // if(this.reguisterform.phone.length == 11){
          if (/^1[3456789]\d{9}$/.test(this.checkform.phone)) {
            this.checkvalue = false
          } else {
            this.checkvalue = true
          }
          // }
          break
      }
    }

    // confirmone(){
    //     this.beforbtn = true
    // },
  }
}
</script>

<style scoped lang="less">
.invoiceModal {
  /deep/ .ivu-modal {
    top: 125px;
  }
  /deep/ .ivu-modal-body {
    padding: 40px 71px;
    text-align: center;
    line-height: 1;
    h4 {
      font-size: 16px;
      color: #ed4112;
    }
    div {
      width: 240px;
      height: 240px;
      padding: 16px;
      margin: 24px auto 0;
      border: 1px solid #eef0f2;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      margin-top: 24px;
      font-size: 14px;
    }
  }
}
.cardbox {
  width: 364px;
  min-height: 369px;
  border-radius: 0 0 8px 8px;
  /* padding: 16px; */
  padding: 32px;
  background: #fff !important;
}

.cardcontent {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cardcontentfp {
  font-size: 12px;
  color: #999999;
  line-height: 12px;
}
.blodp {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  line-height: 18px;
}

.commp {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  line-height: 22px;
}

.boxone {
  width: 300px;
  height: 44px;
  border-bottom: 1px dashed #e5e5e5;
  position: relative;
}

.boxtwo {
  width: 300px;
  position: absolute;
  bottom: -40px;
  display: flex;
  justify-content: space-around;
}

.changebox {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.yuanbox {
  height: 22px;
  width: 22px;
  border-radius: 11px;
  background: #3b80fb;
  line-height: 22px;
  color: #fff;
}

.forgetpwdstyle {
  text-align: right;
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
  cursor: pointer;
}
.forgetpwdstyle:hover {
  color: #576b95;
}
</style>

<style>
.changecont .ivu-tabs-nav {
  width: 300px !important;
  display: flex;
  justify-content: center;
}

.changecont .ivu-tabs-bar {
  margin-bottom: 32px !important;
  border-bottom: 1px solid #eee !important;
}

.changecont .ivu-tabs-ink-bar {
  width: 30px !important;
  left: 60px !important;
}

.modinp .ivu-input {
  height: 42px;
  width: 100%;
  background: #f6f7f9;
  border: 0;
  font-size: 14px;
  border-radius: 4px !important;
}

.modinp .ivu-form-item-content {
  padding: 0 2px;
}

.modinp .ivu-btn {
  border: 0 !important;
}

.modinp .ivu-input-suffix {
  line-height: 48px;
}

.changecont .ivu-tabs-tabpane {
  height: 240px !important;
}

.changecont .ivu-tabs-tab-active {
  color: #333;
}

.changecont .ivu-tabs-tab-focused {
  color: #333 !important;
}

.changecont .ivu-tabs-tab:hover {
  color: #333 !important;
}

.changecont .ivu-tabs-tab {
  color: #666;
}

.cardcontent .ivu-tabs-tab {
  font-size: 18px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/login-form/elselogin-form.vue